export const toPathDataFixed = (objPath) => {
    const decimalPlaces = 2;

    function floatToString(v) {
        if (Math.round(v) === v) {
            return '' + Math.round(v);
        } else {
            return v.toFixed(decimalPlaces);
        }
    }

    function packValues() {
        var arguments$1 = arguments;

        var numbs = [];
        for (var i = 0; i < arguments.length; i += 1) {
            var v = arguments$1[i];
            numbs.push(floatToString(v));
        }

        return numbs.join(' ');
    }

    var commands = [];
    for (var i = 0; i < objPath.commands.length; i += 1) {
        var cmd = objPath.commands[i];
        if (cmd.type === 'M') {
            commands.push('M' + packValues(cmd.x, cmd.y));
        } else if (cmd.type === 'L') {
            commands.push('L' + packValues(cmd.x, cmd.y));
        } else if (cmd.type === 'C') {
            commands.push('C' + packValues(cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y));
        } else if (cmd.type === 'Q') {
            commands.push('Q' + packValues(cmd.x1, cmd.y1, cmd.x, cmd.y));
        } else if (cmd.type === 'Z') {
            commands.push('Z');
        }
    }
    return commands.join(' ');
};
